export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-13.459fc75f.jpg";